// extracted by mini-css-extract-plugin
module.exports = {"Main":"Main_Main__32OVD","Main__title":"Main_Main__title__2EgAV"};